import { RuleProps } from 'types/application';

export const LICENCE_CATEGORY = 'licence-category';
export const STATION_DETAILS = 'station-details';
export const SUPPORTING_DOCUMENTS = 'supporting-documents';

export const SCS_APPLICATION = [
    {
        sectionID: LICENCE_CATEGORY,
        sectionName: 'Licence Category',
        fieldList: [
            {
                id: 'licence-category',
                label: 'Licence Category',
                type: 'text',
                span: 12
            },
            {
                id: 'proposed-use-of-system',
                label: 'Proposed Use of System',
                type: 'text'
            },
            {
                id: 'if-others-please-specify',
                label: 'If others, please specify',
                type: 'text'
            },
            {
                id: 'existing-fbo-or-sbo-licence',
                label: 'Existing FBO or SBO Licence',
                type: 'text'
            },
            {
                id: 'please-enter-fbo-sbo-licence',
                label: 'Please Enter FBO/SBO Licence',
                type: 'text'
            },
            {
                id: 'existing-tvro-licence',
                label: 'Existing TVRO Licence',
                type: 'text'
            },
            {
                id: 'please-enter-tvro-licence',
                label: 'Please Enter TVRO Licence',
                type: 'text'
            },
            {
                id: 'satellite-service',
                label: 'Satellite Service',
                type: 'text',
                rule: {
                    baseIds: [`${LICENCE_CATEGORY}-licence-category`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            baseValues &&
                                baseValues[`${LICENCE_CATEGORY}-licence-category`] !== 'Portable Satellite Communication Terminal Licence'
                        );
                        return result;
                    }
                }
            }
        ]
    },
    {
        sectionID: STATION_DETAILS,
        sectionName: '',
        fieldList: [
            {
                id: 'land-fixed-station-tabs',
                label: '',
                type: 'tab',
                tabs: [
                    {
                        id: 1,
                        label: 'Station 1',
                        content: [
                            {
                                id: 'station-information',
                                label: 'Station Information',
                                type: 'subsection'
                            },
                            {
                                id: 'ground-station-name',
                                label: 'Ground Station Name',
                                type: 'text'
                            },
                            {
                                id: 'desired-commencement-date',
                                label: 'Desired Commencement Date',
                                type: 'text'
                            },
                            {
                                id: 'is-this-a-backup-station',
                                label: 'Is this a backup station ?',
                                type: 'text'
                            },
                            {
                                id: 'please-enter-primary-satellite-communication-station-licence-number',
                                label: 'Please enter primary Satellite Communication Station Licence number',
                                type: 'text'
                            },
                            {
                                id: 'location-of-station',
                                label: 'Location of Station (e.g.Rooftop)',
                                type: 'text',
                                span: 12
                            },
                            {
                                id: 'building-name',
                                label: 'Building Name',
                                type: 'text'
                            },
                            {
                                id: 'postal-code',
                                label: 'Postal Code',
                                type: 'text'
                            },
                            {
                                id: 'street-name',
                                label: 'Street Name',
                                type: 'text'
                            },
                            {
                                id: 'block-house-no',
                                label: 'Block/House No.',
                                type: 'text'
                            },
                            {
                                id: 'unit',
                                label: 'Unit',
                                type: 'text'
                            },
                            {
                                id: 'floor-level',
                                label: 'Floor/Level',
                                type: 'text'
                            },
                            {
                                id: 'is-it-transportable',
                                label: 'Is It Transportable ?',
                                type: 'text'
                            },
                            {
                                id: 'state-radius-operation-km',
                                label: 'State Radius of Operation (km)',
                                type: 'text'
                            },
                            {
                                id: 'latitude',
                                label: 'Latitude',
                                type: 'subsection'
                            },
                            {
                                id: 'latitude-degrees',
                                label: 'Latitude Degrees',
                                type: 'text'
                            },
                            {
                                id: 'latitude-minutes',
                                label: 'Latitude Minutes',
                                type: 'text'
                            },
                            {
                                id: 'latitude-seconds',
                                label: 'Latitude Seconds',
                                type: 'text'
                            },
                            {
                                id: 'longitude',
                                label: 'Longitude',
                                type: 'subsection'
                            },
                            {
                                id: 'longitude-degrees',
                                label: 'Longitude Degrees',
                                type: 'text'
                            },
                            {
                                id: 'longitude-minutes',
                                label: 'Longitude Minutes',
                                type: 'text'
                            },
                            {
                                id: 'longitude-seconds',
                                label: 'Longitude Seconds',
                                type: 'text'
                            },
                            {
                                id: 'antenna-displacement-from-station-location',
                                label: 'Antenna Displacement From Station Location',
                                type: 'subsection'
                            },
                            {
                                id: 'north-latitude-displacement',
                                label: 'North Latitude Displacement (m)',
                                type: 'text'
                            },
                            {
                                id: 'east-latitude-displacement',
                                label: 'East Latitude Displacement (m)',
                                type: 'text'
                            },
                            {
                                id: 'elevation-above-mean-sea-level',
                                label: 'Elevation Above Mean Sea Level (m)',
                                type: 'text'
                            },
                            {
                                id: 'structure-height',
                                label: 'Structure Height (m)',
                                type: 'text'
                            },
                            {
                                id: 'height-of-the-antenna-structure',
                                label: 'Height of the antenna structure(m) (Above ground level)',
                                type: 'text'
                            },
                            {
                                id: 'antenna-height-above-ground-level',
                                label: 'Antenna Height (m) (Above ground level)',
                                type: 'text'
                            },
                            {
                                id: 'lowest-equivalent-satellite-link-noise-temperature',
                                label: 'Lowest Equivalent Satellite Link Noise Temperature (K)',
                                type: 'text'
                            },
                            {
                                id: 'receiver-noise-information',
                                label: 'Receiver Noise Information',
                                type: 'subsection'
                            },
                            {
                                id: 'receiver-noise-temperature-front-end',
                                label: 'Receiver Noise Temperature Front End (K)',
                                type: 'text'
                            },
                            {
                                id: 'receiver-noise-temperature-antenna',
                                label: 'Receiver Noise Temperature Antenna (K)',
                                type: 'text'
                            },
                            {
                                id: 'receiver-noise-temperature-lowest-total-system',
                                label: 'Receiver Noise Temperature Lowest Total System (K)',
                                type: 'text'
                            },
                            {
                                id: 'gain-noise-temperature-ratio',
                                label: 'Gain/Noise Temperature Ratio (dB/K)',
                                type: 'text'
                            },
                            {
                                id: 'data-interface',
                                label: 'Data Interface (Optional)',
                                type: 'text'
                            },
                            {
                                id: 'encryption-scrambling-standard',
                                label: 'Encryption /Scrambling Standard (Optional)',
                                type: 'text'
                            },
                            {
                                id: 'modulation-scheme',
                                label: 'Modulation Scheme',
                                type: 'text'
                            },
                            {
                                id: 'modulation-type',
                                label: 'Modulation Type',
                                type: 'text'
                            },
                            {
                                id: 'feeder-line-information',
                                label: 'Feeder Line Information',
                                type: 'subsection'
                            },
                            {
                                id: 'transmit-type',
                                label: 'Transmit (Type)',
                                type: 'text'
                            },
                            {
                                id: 'receive-type',
                                label: 'Receive (Type)',
                                type: 'text'
                            },
                            {
                                id: 'transmit-length-in-meters',
                                label: 'Transmit (Length in Meters)',
                                type: 'text'
                            },
                            {
                                id: 'receive-length-in-meters',
                                label: 'Receive (Length in Meters)',
                                type: 'text'
                            },
                            {
                                id: 'transmit-path-loss-in-feeder-line',
                                label: 'Transmit path loss in feeder line (dB)',
                                type: 'text'
                            },
                            {
                                id: 'receive-path-loss-in-feeder-line',
                                label: 'Receive path loss in feeder line (dB)',
                                type: 'text'
                            },
                            {
                                id: 'system-emission-power',
                                label: 'System Emission Power (W)',
                                type: 'text'
                            },
                            {
                                id: 'system-emission-power-type',
                                label: 'System Emission Power Type (WERP or WEIRP)',
                                type: 'text'
                            },
                            {
                                id: 'total-peak-power',
                                label: 'Total Peak Power',
                                type: 'subsection'
                            },
                            {
                                id: 'transmit-dbw',
                                label: 'Transmit (+/-dBW)',
                                type: 'text'
                            },
                            {
                                id: 'receive-dbw',
                                label: 'Receive (+/-dBW) (Optional)',
                                type: 'text'
                            },
                            {
                                id: 'maxium-spectral-power-density',
                                label: 'Maximum Spectral Power Density',
                                type: 'subsection'
                            },
                            {
                                id: 'transmit-dbwhz',
                                label: 'Transmit (+/-dBW/Hz)',
                                type: 'text'
                            },
                            {
                                id: 'receive-dbwhz',
                                label: 'Receive (+/-dBW/Hz)',
                                type: 'text'
                            },
                            {
                                id: 'polarization',
                                label: 'Polarization (Linear, Circular, etc)',
                                type: 'subsection'
                            },
                            {
                                id: 'transmit',
                                label: 'Transmit',
                                type: 'text'
                            },
                            {
                                id: 'receive',
                                label: 'Receive',
                                type: 'text'
                            },
                            {
                                id: 'baseband-symbol-rate-digital-only',
                                label: '(Digital Only) Baseband Symbol Rate',
                                type: 'subsection'
                            },
                            {
                                id: 'transmit-kbs',
                                label: 'Transmit (Kb/s)',
                                type: 'text'
                            },
                            {
                                id: 'receive-kbs',
                                label: 'Receive (Kb/s)',
                                type: 'text'
                            },
                            {
                                id: 'baseband-biterror-rate-digital-only',
                                label: '(Digital Only) Baseband Bit-Error Rate (10E-35)',
                                type: 'subsection'
                            },
                            {
                                id: 'transmit-mbs',
                                label: 'Transmit (Mb/s)',
                                type: 'text'
                            },
                            {
                                id: 'receive-mbs',
                                label: 'Receive (Mb/s)',
                                type: 'text'
                            },
                            {
                                id: 'baseband-noise-power-ratio-analog-only',
                                label: '(Analog Only) Baseband Noise/Power ratio',
                                type: 'subsection'
                            },
                            {
                                id: 'transmit-db',
                                label: 'Transmit (dB)',
                                type: 'text'
                            },
                            {
                                id: 'receive-db',
                                label: 'Receive (dB)',
                                type: 'text'
                            },
                            {
                                id: 'baseband-frequency-range-analog-only',
                                label: '(Analog Only) Baseband Frequency Range',
                                type: 'subsection'
                            },
                            {
                                id: 'transmit-mhz',
                                label: 'Transmit (MHz)',
                                type: 'text'
                            },
                            {
                                id: 'receive-mhz',
                                label: 'Receive (MHz)',
                                type: 'text'
                            },
                            {
                                id: 'intermediate-frequency',
                                label: 'Intermediate Frequency',
                                type: 'subsection'
                            },
                            {
                                id: 'transmit-mhz-intermediate',
                                label: 'Transmit (MHz)',
                                type: 'text'
                            },
                            {
                                id: 'receive-mhz-intermediate',
                                label: 'Receive (MHz)',
                                type: 'text'
                            },
                            {
                                id: 'radio-equipment-information-transmit-equipment',
                                label: 'Radio Equipment Information - Transmit Equipment',
                                type: 'subsection'
                            },
                            {
                                id: 'manufacturer-tx',
                                label: 'Manufacturer (Transmit)',
                                type: 'text'
                            },
                            {
                                id: 'trade-name-tx',
                                label: 'Trade Name (Transmit) (Optional)',
                                type: 'text'
                            },
                            {
                                id: 'model-tx',
                                label: 'Model (Transmit)',
                                type: 'text'
                            },
                            {
                                id: 'minimum-operating-frequency-tx',
                                label: 'Minimum Operating Frequency (MHz) (Transmit)',
                                type: 'text'
                            },
                            {
                                id: 'maximum-operating-frequency-tx',
                                label: 'Maximum Operating Frequency (MHz) (Transmit)',
                                type: 'text'
                            },
                            {
                                id: 'intermediate-frequency-3db-bandwidth-tx',
                                label: 'Intermediate Frequency 3dB Bandwidth (KHz) (Transmit)',
                                type: 'text'
                            },
                            {
                                id: 'radio-equipment-information-receive-equipment',
                                label: 'Radio Equipment Information - Receive Equipment',
                                type: 'subsection'
                            },
                            {
                                id: 'manufacturer-rx',
                                label: 'Manufacturer (Receive)',
                                type: 'text'
                            },
                            {
                                id: 'trade-name-rx',
                                label: 'Trade Name (Receive) (Optional)',
                                type: 'text'
                            },
                            {
                                id: 'model-rx',
                                label: 'Model (Receive)',
                                type: 'text'
                            },
                            {
                                id: 'minimum-operating-frequency-rx',
                                label: 'Minimum Operating Frequency (MHz) (Receive)',
                                type: 'text'
                            },
                            {
                                id: 'maximum-operating-frequency-rx',
                                label: 'Maximum Operating Frequency (MHz) (Receive)',
                                type: 'text'
                            },
                            {
                                id: 'intermediate-frequency-3db-bandwidth-rx',
                                label: 'Intermediate Frequency 3dB Bandwidth (KHz) (Receive)',
                                type: 'text'
                            },
                            {
                                id: 'radio-equipment-information-frequency-stability',
                                label: 'Radio Equipment Information - Frequency Stability',
                                type: 'subsection'
                            },
                            {
                                id: 'transmitter-rate-power',
                                label: 'Transmitter Rate Power (W) (Frequency Stability)',
                                type: 'text'
                            },
                            {
                                id: 'minimum-acceptable-rx-signed-level',
                                label: 'Minimum Acceptable Rx Signed level (dBW) (Frequency Stability)',
                                type: 'text'
                            },
                            {
                                id: 'spurious-emissions',
                                label: 'Spurious Emissions',
                                type: 'subsection'
                            },
                            {
                                id: 'transmitter-rate-power-spurious',
                                label: 'Transmitter Rate Power (W) (Spurious Emissions)',
                                type: 'text'
                            },
                            {
                                id: 'minimum-acceptable-rx-signed-level-spurious',
                                label: 'Minimum Acceptable Rx Signed level (dBW) (Spurious Emissions)',
                                type: 'text'
                            },
                            {
                                id: 'antenna-information',
                                label: 'Antenna Information',
                                type: 'subsection'
                            },
                            {
                                id: 'antenna-diameter',
                                label: 'Antenna Diameter (m)',
                                type: 'text'
                            },
                            {
                                id: 'antenna-manufacturer',
                                label: 'Manufacturer',
                                type: 'text'
                            },
                            {
                                id: 'antenna-model',
                                label: 'Model',
                                type: 'text'
                            },
                            {
                                id: 'antenna-type',
                                label: 'Antenna Type',
                                type: 'text'
                            },
                            {
                                id: 'frequency-range',
                                label: 'Frequency Range',
                                type: 'subsection'
                            },
                            {
                                id: 'freq-range-transmit-mhz',
                                label: 'Transmit (MHz)',
                                type: 'text'
                            },
                            {
                                id: 'freq-range-receive-mhz',
                                label: 'Receive (MHz)',
                                type: 'text'
                            },
                            {
                                id: 'midban-gain',
                                label: 'Midband Gain',
                                type: 'subsection'
                            },
                            {
                                id: 'midban-transmit-db',
                                label: 'Transmit (dB)',
                                type: 'text'
                            },
                            {
                                id: 'midban-receive-db',
                                label: 'Receive (dB)',
                                type: 'text'
                            },
                            {
                                id: '3dbeam-width',
                                label: '3dB Beamwidth',
                                type: 'subsection'
                            },
                            {
                                id: 'transmit-degree',
                                label: 'Transmit (degree)',
                                type: 'text'
                            },
                            {
                                id: 'receive-degree',
                                label: 'Receive (degree)',
                                type: 'text'
                            },
                            {
                                id: 'adjust-range',
                                label: 'Adjust Range',
                                type: 'subsection'
                            },
                            {
                                id: 'adjust-range-elevation',
                                label: 'Adjust Range Elevation (degree)',
                                type: 'text'
                            },
                            {
                                id: 'adjust-range-azumuth',
                                label: 'Adjust Range Azumuth (degree) (Optional)',
                                type: 'text'
                            },
                            {
                                id: 'operation-angle',
                                label: 'Operating Angle',
                                type: 'subsection'
                            },
                            {
                                id: 'operating-angle-elevation',
                                label: 'Operating Angle Elevation (degree)',
                                type: 'text'
                            },
                            {
                                id: 'operating-angle-azimuth',
                                label: 'Operating Angle Azimuth (degree)',
                                type: 'text'
                            },
                            {
                                id: 'wind-loading',
                                label: 'Wind Loading',
                                type: 'subsection'
                            },
                            {
                                id: 'operation-kmh',
                                label: 'Operation (km/h)',
                                type: 'text'
                            },
                            {
                                id: 'survival',
                                label: 'Survival',
                                type: 'text'
                            },
                            {
                                id: 'radiation-pattern',
                                label: 'Radiation Pattern',
                                type: 'subsection'
                            },
                            {
                                id: 'required-information-will-be-attached',
                                label: 'Required Information will be attached (Optional)',
                                type: 'text'
                            },
                            {
                                id: 'transmit-receive-radio-frequency-filter-information',
                                label: 'Transmit /Receive Radio Frequency Filter Information',
                                type: 'subsection'
                            },
                            {
                                id: 'filter-manufacturer',
                                label: 'Manufacturer (Filter)(Optional)',
                                type: 'text'
                            },
                            {
                                id: 'filter-model',
                                label: 'Model (Filter)(Optional)',
                                type: 'text'
                            },
                            {
                                id: 'rf-filter-type',
                                label: 'RF Filter Type (e.g.band pass/reject) (Optional)',
                                type: 'text'
                            },
                            {
                                id: 'insertion-loss',
                                label: 'Insertion Loss',
                                type: 'subsection'
                            },
                            {
                                id: 'isolation-a',
                                label: 'Isolation A (dB) (Optional)',
                                type: 'text'
                            },
                            {
                                id: 'isolation-b',
                                label: 'Isolation B (dB) (Optional)',
                                type: 'text'
                            },
                            {
                                id: 'frequency-range-last',
                                label: 'Frequency Range',
                                type: 'subsection'
                            },
                            {
                                id: 'transmit-from-mhz',
                                label: 'Transmit From (MHz)',
                                type: 'text'
                            },
                            {
                                id: 'transmit-to-mhz',
                                label: 'Transmit To (MHz)',
                                type: 'text'
                            },
                            {
                                id: 'transmit-bandwidth-khz',
                                label: 'Transmit Bandwidth (kHz)',
                                type: 'text'
                            },
                            {
                                id: 'receive-bandwidth-khz',
                                label: 'Receive Bandwidth (kHz)',
                                type: 'text'
                            },
                            {
                                id: 'receive-from-mhz',
                                label: 'Receive From (MHz)',
                                type: 'text'
                            },
                            {
                                id: 'receive-to-mhz',
                                label: 'Receive To (MHz)',
                                type: 'text'
                            },
                            {
                                id: 'minimum-separation-mhz',
                                label: 'Minimum Separation (MHz)',
                                type: 'text'
                            },
                            {
                                id: 'tuned-frequency-mhz',
                                label: 'Tuned Frequency (MHz)',
                                type: 'text'
                            },
                            {
                                id: 'satellite-frequency-type-list',
                                label: 'Satellite Frequency Type',
                                type: 'subsection',
                                fieldlist: [
                                    {
                                        id: 'satellite-frequency-type-info-table',
                                        label: '',
                                        type: 'table',
                                        subFields: [
                                            {
                                                id: 'id-no',
                                                header: 'S/N',
                                                type: 'text'
                                            },
                                            {
                                                id: 'assigned-frequency-mhz-from-tx',
                                                header: 'Desired Frequency (MHz) - From (Tx)',
                                                type: 'text'
                                            },
                                            {
                                                id: 'assigned-frequency-mhz-to-tx',
                                                header: 'Desired Frequency (MHz) - To (Tx)',
                                                type: 'text'
                                            },
                                            {
                                                id: 'assigned-frequency-mhz-from-rx',
                                                header: 'Desired Frequency (MHz) - From (Rx)',
                                                type: 'text'
                                            },
                                            {
                                                id: 'assigned-frequency-mhz-to-rx',
                                                header: 'Desired Frequency (MHz) - To (Rx)',
                                                type: 'text'
                                            },
                                            {
                                                id: 'assigned-bandwidth-khz-tx',
                                                header: 'Desired (kHz)(Tx)',
                                                type: 'text'
                                            },
                                            {
                                                id: 'assigned-bandwidth-khz-rx',
                                                header: 'Desired (kHz)(Rx)',
                                                type: 'text'
                                            },
                                            {
                                                id: 'start-time',
                                                header: 'Start Time',
                                                type: 'text'
                                            },
                                            {
                                                id: 'stop-time',
                                                header: 'Stop Time',
                                                type: 'text'
                                            }
                                        ]
                                    },
                                    {
                                        id: 'frequency-and-emission-class-info-accordion',
                                        label: '',
                                        type: 'accordion',
                                        subFields: [
                                            {
                                                id: 'satellite-type',
                                                label: 'Satellite Type',
                                                type: 'text'
                                            },
                                            {
                                                id: 'orbital-longitude',
                                                label: 'Orbital Longitude',
                                                type: 'text'
                                            },
                                            {
                                                id: 'name-of-satellite-operator',
                                                label: 'Name of Satellite Operator',
                                                type: 'text'
                                            },
                                            {
                                                id: 'associated-space-station',
                                                label: 'Associated Space Station',
                                                type: 'text'
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ],
                span: 12
            }
        ]
    },
    {
        sectionID: SUPPORTING_DOCUMENTS,
        sectionName: 'Supporting Documents',
        fieldList: [
            {
                id: 'supporting-documents',
                label: ' ',
                type: 'file',
                span: 12
            }
        ]
    }
];
